import { makeStyles } from 'tss-react/mui';

const name = 'GroupTabs';

export const useGroupTabsStyles = makeStyles({ name })(() => ({
  root: {
    '&': {
      //borderRadius: theme.shape.borderRadiusMd, // ex 11
    },
  },
}));
